import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { CircularProgress, ThemeProvider } from "@mui/material";
import { PersistGate } from "redux-persist/integration/react";
import theme from "./constants/Theme/";
import { Provider } from "react-redux";
import { persistor, store } from "./app/store";
import { Helmet, HelmetProvider } from "react-helmet-async";
ReactDOM.render(
  <React.StrictMode>
    <ThemeProvider theme={theme}>
      <Provider store={store}>
        <PersistGate loading={<CircularProgress />} persistor={persistor}>
          <HelmetProvider>
            <Helmet titleTemplate={`AllDay | %s`} defaultTitle={`AllDay`} />
            <App />
          </HelmetProvider>
        </PersistGate>
      </Provider>
    </ThemeProvider>
  </React.StrictMode>,
  document.getElementById("root")
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
